import { getOsType, getSubDomain, isEnumValue } from '@core/utils';
import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { SUB_DOMAIN } from '@/constants/domain';
import { isKbWebview } from '@/modules/kb-pay';

import { useDeviceInfoStore, WEBVIEW_TYPE } from './useDeviceInfoStore';

export const useMountDeviceInfoStore = () => {
  const [
    setIsMounted,
    setWebviewType,
    setOsType,
    setViewportType,
    setSubDomain,
  ] = useDeviceInfoStore(
    useShallow((state) => [
      state.setIsMounted,
      state.setWebviewType,
      state.setOsType,
      state.setViewportType,
      state.setSubDomain,
    ]),
  );

  useEffect(() => {
    const subDomain = getSubDomain();

    const { userAgent } = navigator;

    setOsType(getOsType());

    setViewportType(/Mobile/.exec(userAgent) ? 'mobile' : 'desktop');

    if (isEnumValue(SUB_DOMAIN, subDomain)) {
      setSubDomain(subDomain);

      switch (subDomain) {
        case SUB_DOMAIN.KB_PAY: {
          if (isKbWebview()) setWebviewType(WEBVIEW_TYPE.KB_PAY);

          break;
        }

        case SUB_DOMAIN.WELLO_APP: {
          if (userAgent.includes('welfarehello'))
            setWebviewType(WEBVIEW_TYPE.WELLO_APP);

          break;
        }

        case SUB_DOMAIN.TOSS: {
          if (userAgent.includes('Toss')) setWebviewType(WEBVIEW_TYPE.TOSS);

          break;
        }

        default:
          break;
      }
    } else {
      setSubDomain(null);
    }

    setIsMounted(true);
  }, [setIsMounted, setOsType, setSubDomain, setViewportType, setWebviewType]);
};
